import { Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { DisabledUserGuard } from './guards/disabled-user.guard';
import { PublicGuard } from './guards/public.guard';

export const routes: Routes = [
  {
    // Página legal pública (Términos y Privacidad): accesible con y sin sesión
    path: 'legal',
    loadComponent: () => import('./legal/legal-page.component').then(m => m.LegalPageComponent)
  },
  { path: 'terms', redirectTo: 'legal', pathMatch: 'full' },
  { path: 'privacy', redirectTo: 'legal', pathMatch: 'full' },
  {
    path: '',
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule),
    canActivate: [PublicGuard]
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivate: [AuthGuard, DisabledUserGuard]
  },
  { path: 'assistant', redirectTo: '/dashboard/ayuda?tab=breaky', pathMatch: 'full' },
  { path: 'home', redirectTo: 'dashboard/home', pathMatch: 'full' },
  { path: 'ejercicios', redirectTo: 'dashboard/ejercicios', pathMatch: 'full' }
];

